import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { annularPurchaseOperationData } from "../../../apis/apis.logistics/apisProduct";
import swal from "sweetalert2";

const thBase =
    "px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300";
const tdBase =
    "px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle";

export function OrderPurchaseList({
    orders,
    setDetailsFromOrderPurchaseReceived,
}) {
    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(null);

    const annularPurchaseOperation = async (id) => {
        try {
            const response = await annularPurchaseOperationData({
                operationID: id,
            });
            return response;
        } catch (error) {
            throw error;
        }
    };

    const handleAnular = async (id) => {
        const result = await swal.fire({
            title: "¿Está usted seguro?",
            text: "¿Está usted seguro de anular la orden?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#dc2626",
            cancelButtonColor: "#6b7280",
            confirmButtonText: "Sí, anular",
            cancelButtonText: "Cancelar",
        });

        if (result.isConfirmed) {
            try {
                const r = await annularPurchaseOperation(id);
                if (r.status == 201) {
                    toast.success("Orden anulada con éxito!");
                } else {
                    toast.error("Ocurrió algún error");
                }
                document.getElementById("btn-filter").click();
            } catch (error) {
                console.error(error);
            }
        }
    };

    return (
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm mb-4">
            <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex justify-end">
                <Link
                    to="/buys/new_purchase_order"
                    className="inline-flex items-center gap-2 rounded-lg bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-medium px-4 py-2 transition-colors"
                >
                    <i className="fas fa-plus"></i>
                    Nueva Orden
                </Link>
            </div>

            <div className="hidden md:block overflow-y-visible">
                <table className="min-w-full text-sm border-separate border-spacing-0">
                    <thead className="sticky top-0 z-10">
                        <tr>
                            <th className={`${thBase}`}>#</th>
                            <th className={`${thBase}`}>Código</th>
                            <th className={`${thBase}`}>Estado</th>
                            <th className={`${thBase}`}>Fecha</th>
                            <th className={`${thBase}`}>N° Documento</th>
                            <th className={`${thBase}`}>Total (S/)</th>
                            <th className={`${thBase}`}>Cond. IGV</th>
                            <th className={`${thBase}`}>RUC</th>
                            <th className={`${thBase}`}>Proveedor</th>
                            <th className={`${thBase}`}>Artículos</th>
                            <th className={`${thBase}`}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((o, index) => {
                            return (
                                <tr
                                    key={index}
                                    value={o.operationID}
                                    className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                                >
                                    <td
                                        className={`${tdBase} text-blue-600 dark:text-blue-400 font-medium text-center`}
                                    >
                                        {o.operationID}
                                    </td>
                                    <td className={`${tdBase} text-center`}>
                                        {o.code}
                                    </td>
                                    <td className={`${tdBase} text-center`}>
                                        {o.operationStatus == "01" ? (
                                            <span className="px-2 py-1 rounded-full text-xs font-semibold bg-lime-100 text-lime-700 dark:bg-lime-900/30 dark:text-lime-400">
                                                {o.operationStatusDisplay}
                                            </span>
                                        ) : o.operationStatus == "08" ? (
                                            <span className="px-2 py-1 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400">
                                                {o.operationStatusDisplay}
                                            </span>
                                        ) : (
                                            <span className="px-2 py-1 rounded-full text-xs font-semibold bg-fuchsia-100 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:text-fuchsia-400">
                                                {o.operationStatusDisplay}
                                            </span>
                                        )}
                                    </td>
                                    <td className={`${tdBase} text-center`}>
                                        {o.operationDate}
                                    </td>
                                    <td className={`${tdBase} text-center`}>
                                        {o.operationDocumentNumber || "-"}
                                    </td>
                                    <td className={`${tdBase} text-right`}>
                                        S/{" "}
                                        {Number(
                                            o.operationAmountTotal || 0,
                                        ).toFixed(2)}
                                        {Number(o.operationAmountFree || 0) >
                                            0 && (
                                            <div className="text-[10px] font-normal text-amber-600 dark:text-amber-400">
                                                <i className="fas fa-gift mr-0.5"></i>
                                                +S/{" "}
                                                {Number(
                                                    o.operationAmountFree,
                                                ).toFixed(2)}{" "}
                                                gratis
                                            </div>
                                        )}
                                    </td>
                                    <td className={`${tdBase} text-center`}>
                                        <span
                                            className={`px-2 py-1 rounded-full text-xs font-semibold ${
                                                o.conditionIgv === "01"
                                                    ? "bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400"
                                                    : "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400"
                                            }`}
                                        >
                                            {o.conditionIgv === "01"
                                                ? "INCLUIDO"
                                                : "APARTE"}
                                        </span>
                                    </td>
                                    <td className={`${tdBase} text-center`}>
                                        {o.supplierDocumentNumber}
                                    </td>
                                    <td className={`${tdBase}`}>
                                        {o.supplierName}
                                    </td>
                                    <td className={`${tdBase} text-center`}>
                                        {o.operationNumberItems}
                                    </td>
                                    <td className={`${tdBase} text-right`}>
                                        {o.operationStatus == "01" ? (
                                            <div className="relative inline-block text-left">
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setIsDropdownOpen(
                                                            isDropdownOpen ===
                                                                index
                                                                ? null
                                                                : index,
                                                        )
                                                    }
                                                    className="inline-flex items-center gap-2 rounded-lg border border-blue-300 dark:border-blue-700 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 text-sm font-medium px-3 py-1 transition-colors"
                                                >
                                                    Acciones{" "}
                                                    <i className="fas fa-caret-down"></i>
                                                </button>
                                                {isDropdownOpen === index && (
                                                    <div className="absolute right-0 mt-1 w-48 bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 shadow-lg overflow-hidden z-50">
                                                        <Link
                                                            to={
                                                                "/buys/edit_purchase_order/" +
                                                                o.operationID
                                                            }
                                                            className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
                                                        >
                                                            <i className="fas fa-highlighter"></i>
                                                            Editar
                                                        </Link>
                                                        <Link
                                                            to={
                                                                "/buys/receive_purchase_order/" +
                                                                o.operationID
                                                            }
                                                            className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
                                                        >
                                                            <i className="fas fa-archive"></i>
                                                            Recibir
                                                        </Link>
                                                        <Link
                                                            to={
                                                                "/buys/conclude_purchase_order/" +
                                                                o.operationID
                                                            }
                                                            className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
                                                        >
                                                            <i className="fas fa-clipboard-check"></i>
                                                            Concluir
                                                        </Link>
                                                        <div className="h-px bg-gray-200 dark:bg-gray-600 my-1"></div>
                                                        <button
                                                            onClick={() =>
                                                                handleAnular(
                                                                    o.operationID,
                                                                )
                                                            }
                                                            className="flex items-center gap-2 px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 w-full text-left transition-colors"
                                                        >
                                                            <i className="fas fa-ban"></i>
                                                            Anular
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        ) : o.operationStatus == "08" ? (
                                            <div className="relative inline-block text-left">
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setIsDropdownOpen(
                                                            isDropdownOpen ===
                                                                index
                                                                ? null
                                                                : index,
                                                        )
                                                    }
                                                    className="inline-flex items-center gap-2 rounded-lg border border-blue-300 dark:border-blue-700 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 text-sm font-medium px-3 py-1 transition-colors"
                                                >
                                                    Acciones{" "}
                                                    <i className="fas fa-caret-down"></i>
                                                </button>
                                                {isDropdownOpen === index && (
                                                    <div className="absolute right-0 mt-1 w-48 bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 shadow-lg overflow-hidden z-50">
                                                        <Link
                                                            to={
                                                                "/buys/review_purchase_order/" +
                                                                o.operationID
                                                            }
                                                            className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
                                                        >
                                                            <i className="fas fa-highlighter"></i>
                                                            Revisar
                                                        </Link>
                                                    </div>
                                                )}
                                            </div>
                                        ) : null}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="md:hidden divide-y divide-gray-100 dark:divide-gray-700">
                {orders.map((o, index) => (
                    <div key={index} className="p-4">
                        <div className="flex items-start justify-between mb-3">
                            <div>
                                <p className="text-sm font-semibold text-gray-900 dark:text-white">
                                    {o.code}
                                </p>
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                    {o.supplierName}
                                </p>
                            </div>
                            {o.operationStatus == "01" ? (
                                <span className="px-2 py-1 rounded-full text-xs font-semibold bg-lime-100 text-lime-700 dark:bg-lime-900/30 dark:text-lime-400">
                                    {o.operationStatusDisplay}
                                </span>
                            ) : o.operationStatus == "08" ? (
                                <span className="px-2 py-1 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400">
                                    {o.operationStatusDisplay}
                                </span>
                            ) : (
                                <span className="px-2 py-1 rounded-full text-xs font-semibold bg-fuchsia-100 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:text-fuchsia-400">
                                    {o.operationStatusDisplay}
                                </span>
                            )}
                        </div>

                        <div className="grid grid-cols-2 gap-3 text-xs mb-3">
                            <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                                <p className="text-gray-500 dark:text-gray-400 mb-0.5">
                                    Fecha
                                </p>
                                <p className="font-semibold text-gray-700 dark:text-gray-300">
                                    {o.operationDate}
                                </p>
                            </div>
                            <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                                <p className="text-gray-500 dark:text-gray-400 mb-0.5">
                                    Total
                                </p>
                                <p className="font-semibold text-gray-700 dark:text-gray-300">
                                    S/{" "}
                                    {Number(
                                        o.operationAmountTotal || 0,
                                    ).toFixed(2)}
                                </p>
                                {Number(o.operationAmountFree || 0) > 0 && (
                                    <p className="text-[10px] text-amber-600 dark:text-amber-400">
                                        <i className="fas fa-gift mr-0.5"></i>
                                        +S/{" "}
                                        {Number(
                                            o.operationAmountFree,
                                        ).toFixed(2)}{" "}
                                        gratis
                                    </p>
                                )}
                            </div>
                            <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                                <p className="text-gray-500 dark:text-gray-400 mb-0.5">
                                    RUC
                                </p>
                                <p className="font-semibold text-gray-700 dark:text-gray-300">
                                    {o.supplierDocumentNumber}
                                </p>
                            </div>
                            <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg px-3 py-1.5">
                                <p className="text-gray-500 dark:text-gray-400 mb-0.5">
                                    Artículos
                                </p>
                                <p className="font-semibold text-gray-700 dark:text-gray-300">
                                    {o.operationNumberItems}
                                </p>
                            </div>
                        </div>

                        {o.operationStatus == "01" ||
                        o.operationStatus == "08" ? (
                            <div className="flex flex-wrap gap-2">
                                {o.operationStatus == "01" && (
                                    <>
                                        <Link
                                            to={
                                                "/buys/edit_purchase_order/" +
                                                o.operationID
                                            }
                                            className="inline-flex items-center gap-1 rounded-lg border border-amber-300 dark:border-amber-700 text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 text-sm font-medium px-3 py-1.5 transition-colors flex-1 justify-center"
                                        >
                                            <i className="fas fa-highlighter"></i>
                                            Editar
                                        </Link>
                                        <Link
                                            to={
                                                "/buys/receive_purchase_order/" +
                                                o.operationID
                                            }
                                            className="inline-flex items-center gap-1 rounded-lg border border-green-300 dark:border-green-700 text-green-600 dark:text-green-400 hover:bg-green-50 dark:hover:bg-green-900/20 text-sm font-medium px-3 py-1.5 transition-colors flex-1 justify-center"
                                        >
                                            <i className="fas fa-archive"></i>
                                            Recibir
                                        </Link>
                                        <Link
                                            to={
                                                "/buys/conclude_purchase_order/" +
                                                o.operationID
                                            }
                                            className="inline-flex items-center gap-1 rounded-lg border border-cyan-300 dark:border-cyan-700 text-cyan-600 dark:text-cyan-400 hover:bg-cyan-50 dark:hover:bg-cyan-900/20 text-sm font-medium px-3 py-1.5 transition-colors flex-1 justify-center"
                                        >
                                            <i className="fas fa-clipboard-check"></i>
                                            Concluir
                                        </Link>
                                        <button
                                            onClick={() =>
                                                handleAnular(o.operationID)
                                            }
                                            className="inline-flex items-center gap-1 rounded-lg border border-red-300 dark:border-red-700 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 text-sm font-medium px-3 py-1.5 transition-colors flex-1 justify-center"
                                        >
                                            <i className="fas fa-ban"></i>
                                            Anular
                                        </button>
                                    </>
                                )}
                                {o.operationStatus == "08" && (
                                    <Link
                                        to={
                                            "/buys/review_purchase_order/" +
                                            o.operationID
                                        }
                                        className="inline-flex items-center gap-1 rounded-lg border border-amber-300 dark:border-amber-700 text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 text-sm font-medium px-3 py-1.5 transition-colors flex-1 justify-center"
                                    >
                                        <i className="fas fa-highlighter"></i>
                                        Revisar
                                    </Link>
                                )}
                            </div>
                        ) : null}
                    </div>
                ))}
            </div>
        </div>
    );
}
